import { useState, useEffect } from 'react';
import { createReadonlyObservable } from '@paradigm/utils/src/createObservable';
import { useObservable } from '@paradigm/utils/src/hooks';
import { Bbo } from '../entities/drfq/bbo';
import { useDrfqBboService } from './drfqs';

const [EMPTY_BBO] = createReadonlyObservable<Bbo | null>('empty-bbo', null);

export default function useDrfqBbo(rfqId: string) {
  const bboService = useDrfqBboService();

  const [observable, setObservable] = useState(EMPTY_BBO);

  useEffect(() => {
    const [release, bbo] = bboService.acquireRfqBbo(rfqId);
    setObservable(bbo);
    return release;
  }, [rfqId, bboService]);

  return useObservable(observable);
}
